import { c as _c } from "react/compiler-runtime";
import React from 'react';
import classNames from 'classnames';
import CtaButton from 'components/essentials/Cta/CtaButton';
const LoadMoreButton = t0 => {
  const $ = _c(5);
  const {
    onClick,
    disabled: t1,
    isLoading: t2
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const isLoading = t2 === undefined ? false : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = classNames("flex p-2 relative");
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== disabled || $[2] !== isLoading || $[3] !== onClick) {
    t4 = <div className="flex justify-center items-center gap-4 cursor-pointer"><div className={t3}><span className="z-20 bg-white p-[5px] rounded-md"><CtaButton onClick={onClick} isLoading={isLoading} styling="outline-button" disabled={disabled}>Load More</CtaButton></span></div></div>;
    $[1] = disabled;
    $[2] = isLoading;
    $[3] = onClick;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
export default LoadMoreButton;